import React, { Children, cloneElement } from 'react';
import styles from "./StepperProgress.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function StepperProgress({
  children,
  activeIndex
}) {
  const normalizedChildren = Children.map(children, (child, index) => {
    return /*#__PURE__*/cloneElement(child, {
      ...child.props,
      __active: index <= activeIndex,
      __currentStep: index === activeIndex
    });
  });
  return /*#__PURE__*/_jsx("section", {
    role: "presentation",
    className: styles.progress,
    children: normalizedChildren
  });
}